/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { FormattedMessage, useIntl } from 'react-intl'
import { useNavigate } from 'react-router'
import AppVersion from '../../../client/js/components/AppVersion'
import ButtonGroup from '../../../client/js/components/form/ButtonGroup'
import FormField from '../../../client/js/components/form/fields/FormField'
import FormSubmitButton from '../../../client/js/components/form/buttons/FormSubmitButton'
import PageTitle from '../../../client/js/components/PageTitle'
import {
  createFieldInitializer,
  createFieldValidator,
  createFormValidator
} from '../../../client/js/lib/form'
import { postResetPassword } from '../lib/passwordAPIClient'
import ResetPasswordFormSchema from '../schemas/ResetPasswordFormSchema.mjs'
import { getPasswordUpdateLink } from '../lib/passwordLinks'
import { Card, Stack, Text } from '@mantine/core'
import AnchorLink from '../../../client/js/components/AnchorLink'
import { getSignInLink } from '../../auth/lib/authLinks'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons/faEnvelope'
import SmartForm from '../../../client/js/components/form/SmartForm'
import useCustomForm from '../../../client/js/hooks/useCustomForm'
import Page from '../../../client/js/components/Page'

function ResetPasswordFormPage () {
  const intl = useIntl()
  const navigate = useNavigate()

  const form = useCustomForm({
    initialValues: { email: '' },
    initializeField: createFieldInitializer(ResetPasswordFormSchema),
    validateField: createFieldValidator(ResetPasswordFormSchema),
    validate: createFormValidator(ResetPasswordFormSchema),
    onSubmit: postResetPassword,
    onSuccess (result) {
      const { requestId } = result.content
      // Redirect user to next step after sending email.
      navigate(getPasswordUpdateLink({ requestId }))
    }
  })

  return (
    <Page>
      <Stack w="100%" maw={450}>
        <Card shadow="sm" p="xl">
          <SmartForm context={form}>
            <Stack>
              <PageTitle
                size="h2"
                title={intl.formatMessage({
                  id: 'password_forgotten',
                  defaultMessage: 'Mot de passe oublié'
                })}
              />
              <Text>
                <FormattedMessage
                  id="enter_email_to_reset_password"
                  defaultMessage="Entrez l'adresse électronique associée à votre compte et nous vous enverrons par e-mail, un code qui vous permettra de définir un nouveau mot de passe."
                />
              </Text>
              <FormField
                autoComplete="email"
                label={intl.formatMessage({
                  id: 'email',
                  defaultMessage: 'Adresse électronique'
                })}
                name="email"
                leftSection={<FontAwesomeIcon icon={faEnvelope} />}
              />
              <ButtonGroup>
                <FormSubmitButton
                  fullWidth
                  size="lg"
                  label={intl.formatMessage({
                    id: 'send_an_email',
                    defaultMessage: 'Envoyer un email'
                  })}
                />
              </ButtonGroup>
              <Text size="sm" ta="center">
                <AnchorLink to={getSignInLink()}>
                  <FormattedMessage
                    id="go_to_auth_page"
                    defaultMessage="Retourner sur la page d'authentification"
                  />
                </AnchorLink>
              </Text>
            </Stack>
          </SmartForm>
        </Card>
        <Text ta="center">
          <AppVersion />
        </Text>
      </Stack>
    </Page>
  )
}

export default ResetPasswordFormPage
